/**
 * 使用指令默认设置图片样式为： object-fit: cover 或者设置背景图片为： background-size: cover
 * img标签：如果传参[x, y]，则压缩图片的宽高为： w: x, h: y
 * 其他标签暂时不支持压缩
 *
 * 使用方法：
 * img标签： <img v-zipImg /> or <img v-zipImg="[x, y]" />
 * 普通标签：<div v-zipImg></div>
 */
// 引入压缩方法
import { imgZip } from 'app/web/filters/ossImg.js'

export default {
  zipImg: {
    bind(el, binding, vnode) {
      // 由于经常性忘记设置图片size， 故默认设置为cover
      if (vnode.tag === 'img') {
        el.style.objectFit = 'cover'
        // 如果传参，则压缩，如果不传，则不压缩
        if (vnode?.data?.attrs?.src) {
          let imgURL = vnode?.data?.attrs?.src //获取图片真实地址
          let value = binding.value
          let zipImgURL = value ? imgZip(imgURL, value[0], value[1]) : imgURL
          el.setAttribute('src', zipImgURL)
        }
      } else {
        el.style.backgroundSize = 'cover'
      }
    }
  }
}
